import mainViewMixin from '../mainViewMixin';
export default {
  name: 'ViewNiotaClassicDeviceTypesDeviceTypesList',
  mixins: [mainViewMixin],
  data: function () {
    return {
      accountId: false,
      findCertified: false,
      editedItem: null
    };
  },
  computed: {
    headerBG() {
      return './img/consumer.png';
    },
    deviceTypeButtons() {
      return [{
        title: this.$i18n_t('NiotaClassic.DeviceTypes.filterDigimondoCertified'),
        icon: `${!this.findCertified ? 'fal' : 'fas'} fa-filter`,
        action: 'toogleCertifiedFilter',
        valid: true
      }, {
        title: this.$i18n_t('NiotaClassic.DeviceTypes.filterUsedDeviceTypes'),
        icon: `${!this.accountId ? 'fal' : 'fas'} fa-filter`,
        action: 'toggleAccountFilter',
        valid: true
      }, {
        // title: this.$i18n_t('NiotaClassic.DeviceTypes.filterUsedDeviceTypes'),
        icon: 'fal fa-undo',
        action: 'resetFilter',
        valid: true
      }, ...this.buttons];
    }
  },
  watch: {},
  created() {
    this.setFilterFromQueryParams();
  },
  methods: {
    setFilterFromQueryParams() {
      const filterUsed = this.$route.query.filterUsed;
      const filterCertified = this.$route.query.filterCertified;
      if (filterUsed) {
        this.accountId = true;
      }
      if (filterCertified) {
        this.findCertified = true;
      }
    },
    toggleAccountFilter() {
      this.accountId = !this.accountId;
    },
    toogleCertifiedFilter() {
      this.findCertified = !this.findCertified;
    },
    editItem(item) {
      this.editedItem = item;
      this.formDialog = true;
    },
    updateList() {
      this.$refs.list.fetchList();
    },
    resetFilter() {
      this.accountId = false;
      this.findCertified = false;
    }
  }
};